import React, { ReactElement } from 'react';
import IconProps from '../IconProps';

export default function IconDoor({ color = '#000000', title, ...rest }: IconProps): ReactElement {
    return (
        <svg width='24' height='24' viewBox='0 0 24 24' {...rest} xmlns='http://www.w3.org/2000/svg'>
            {title && <title>{title}</title>}
            <g fill='none' fillRule='evenodd'>
                <g fillRule='nonzero' fill={color}>
                    <g transform='translate(4 4)'>
                        <path d='M1,7.15548648 L1,13.5864258 L14,13.5864258 L14,1.28808594 L5.60272688,1.28808594 L1,7.15548648 Z M-0.786798449,6.19284858 L4.32941249,-0.329124076 C4.51897857,-0.570776511 4.80907709,-0.711914062 5.11621094,-0.711914062 L15,-0.711914062 C15.5522847,-0.711914062 16,-0.264198812 16,0.288085938 L16,14.5864258 C16,15.1387105 15.5522847,15.5864258 15,15.5864258 L0,15.5864258 C-0.55228475,15.5864258 -1,15.1387105 -1,14.5864258 L-1,6.81005859 C-1,6.58626116 -0.924928468,6.36893206 -0.786798449,6.19284858 Z' />
                        <path d='M6.03888553,6.578125 L11,6.578125 L11,4.50868056 L7.64107166,4.50868056 L6.03888553,6.578125 Z M7.15060764,2.50868056 L12,2.50868056 C12.5522847,2.50868056 13,2.95639581 13,3.50868056 L13,7.578125 C13,8.13040975 12.5522847,8.578125 12,8.578125 L4,8.578125 C3.16888266,8.578125 2.70048805,7.62312201 3.20928288,6.9659433 L6.35989052,2.89649886 C6.54928264,2.65187279 6.84123523,2.50868056 7.15060764,2.50868056 Z' />
                    </g>
                </g>
            </g>
        </svg>
    );
}
